import { createFileRoute, } from '@tanstack/react-router'
import { IntegrationsPage } from "@/pages/integrations";

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/integrations',
)({
  component: IntegrationsPage,
  staticData: {
    pageHeader: { title: 'Integrations', pad: false },
  },
})


// const PROVIDERS = SCREENATA_CLOUD_PROVIDERS

// function asSummary(summary: Record<string, unknown> | null | undefined): {
//   pass: number
//   warn: number
//   fail: number
//   error: number
// } | null {
//   if (!summary) return null
//   const pass = typeof summary.pass === 'number' ? summary.pass : null
//   const warn = typeof summary.warn === 'number' ? summary.warn : null
//   const fail = typeof summary.fail === 'number' ? summary.fail : null
//   const error = typeof summary.error === 'number' ? summary.error : null
//   if (pass === null || warn === null || fail === null || error === null) {
//     return null
//   }
//   return { pass, warn, fail, error }
// }

// function formatDate(value: string | null): string | null {
//   if (!value) return null
//   const parsed = new Date(value)
//   if (Number.isNaN(parsed.getTime())) return null
//   return parsed.toLocaleString()
// }

// function ScreenataIntegrationsPage() {
//   const { workspaceId } = useParams({
//     from: '/(protected)/workspaces/$workspaceId/integrations',
//   })
//   const navigate = useNavigate()
//   const queryClient = useQueryClient()
//   const [activeProviderId, setActiveProviderId] = useState<CloudProvider>('aws')
//   const [runningProviderId, setRunningProviderId] = useState<CloudProvider | null>(null)

//   const programQuery = useQuery(
//     trpc.complianceProgram.getProgram.queryOptions({ framework: 'SOC2' }),
//   )
//   const program = programQuery.data
//   const activeProvider =
//     PROVIDERS.find((provider) => provider.id === activeProviderId) ?? PROVIDERS[0]

//   const {
//     configuringProviderId,
//     setConfiguringProviderId: setSharedConfiguringProviderId,
//     connectingProviderId,
//     connectionsByProvider,
//     connectProviderWithOAuth,
//     disconnectProvider,
//     saveAndTestConnection,
//     upsertCloudConnectionMutation,
//     testCloudConnectionMutation,
//     disconnectCloudConnectionMutation,
//   } = useScreenataCloudConnectionManager({
//     onConnected: (provider) => {
//       setActiveProviderId(provider)
//     },
//   })

//   const activeConnection = connectionsByProvider.get(activeProvider.id) ?? {
//     provider: activeProvider.id,
//     connected: false,
//     integrationId: null,
//     hasConfig: false,
//     configSummary: {},
//     lastTestedAt: null,
//     lastTestStatus: null,
//     lastScanAt: null,
//     lastScanSummary: null,
//   }

//   const skipScanningMutation = useMutation(
//     trpc.complianceProgram.skipScanning.mutationOptions(),
//   )
//   const completeIntegrationsMutation = useMutation(
//     trpc.complianceProgram.completeIntegrations.mutationOptions(),
//   )
//   const runCloudScanMutation = useMutation(
//     trpc.integrations.runCloudScan.mutationOptions(),
//   )

//   const findingsQuery = useQuery({
//     ...trpc.integrations.getCloudScanFindings.queryOptions({
//       programId: program?.id ?? '',
//       provider: activeProvider.id,
//     }),
//     enabled: !!program?.id && activeConnection.connected,
//     refetchInterval: (query) => {
//       if (runningProviderId === activeProvider.id) return 1200
//       const phase = query.state.data?.phase
//       if (phase === 'queued' || phase === 'clone' || phase === 'analysis') {
//         return 1200
//       }
//       return false
//     },
//     refetchIntervalInBackground: true,
//   })

//   useEffect(() => {
//     const firstConnected = PROVIDERS.find((provider) =>
//       connectionsByProvider.get(provider.id)?.connected,
//     )
//     if (firstConnected && !connectionsByProvider.get(activeProviderId)?.connected) {
//       setActiveProviderId(firstConnected.id)
//     }
//   }, [activeProviderId, connectionsByProvider])

//   const handleRunScan = (providerId: CloudProvider) => {
//     if (!program?.id) return
//     setActiveProviderId(providerId)
//     setRunningProviderId(providerId)

//     runCloudScanMutation.mutate(
//       {
//         programId: program.id,
//         provider: providerId,
//       },
//       {
//         onSuccess: async () => {
//           await Promise.all([
//             queryClient.invalidateQueries({
//               queryKey: trpc.integrations.getCloudScanFindings.queryKey({
//                 programId: program.id,
//                 provider: providerId,
//               }),
//             }),
//             queryClient.invalidateQueries({
//               queryKey: trpc.integrations.getCloudConnections.queryKey(),
//             }),
//             queryClient.invalidateQueries({
//               queryKey: trpc.complianceProgram.getProgram.queryKey({ framework: 'SOC2' }),
//             }),
//           ])
//         },
//         onError: (error: unknown) => {
//           toast.error(toErrorMessage(error, 'Cloud scan failed'))
//         },
//         onSettled: () => {
//           setRunningProviderId((current) =>
//             current === providerId ? null : current,
//           )
//         },
//       },
//     )
//   }

//   const handleDisconnect = async (providerId: CloudProvider) => {
//     await disconnectProvider(providerId)
//   }

//   const handleSkipScanning = () => {
//     if (!program?.id) return
//     skipScanningMutation.mutate(
//       { programId: program.id },
//       {
//         onSuccess: () => {
//           queryClient.invalidateQueries({
//             queryKey: trpc.complianceProgram.getProgram.queryKey({ framework: 'SOC2' }),
//           })
//           navigate({
//             to: '/workspaces/$workspaceId/scope-confirm',
//             params: { workspaceId },
//           })
//         },
//       },
//     )
//   }

//   const markReviewedMutation = useMutation(
//     trpc.complianceProgram.markContextMemoryReviewed.mutationOptions(),
//   )

//   const handleContinue = () => {
//     if (!program?.id) return
//     completeIntegrationsMutation.mutate(
//       { programId: program.id },
//       {
//         onSuccess: () => {
//           // Auto-mark context memory as reviewed (review step removed — editing happens in connect-repo's AnalysisDrawer)
//           markReviewedMutation.mutate(
//             { framework: 'SOC2' },
//             {
//               onSuccess: () => {
//                 queryClient.invalidateQueries({
//                   queryKey: trpc.complianceProgram.getProgram.queryKey({ framework: 'SOC2' }),
//                 })
//                 navigate({
//                   to: '/workspaces/$workspaceId/scope-confirm',
//                   params: { workspaceId },
//                 })
//               },
//               onError: () => {
//                 // Even if marking fails, still navigate forward
//                 queryClient.invalidateQueries({
//                   queryKey: trpc.complianceProgram.getProgram.queryKey({ framework: 'SOC2' }),
//                 })
//                 navigate({
//                   to: '/workspaces/$workspaceId/scope-confirm',
//                   params: { workspaceId },
//                 })
//               },
//             },
//           )
//         },
//       },
//     )
//   }

//   const footer = (
//     <>
//       <button
//         onClick={handleContinue}
//         disabled={
//           completeIntegrationsMutation.isPending ||
//           runCloudScanMutation.isPending ||
//           connectingProviderId !== null
//         }
//         className="inline-flex items-center gap-2 rounded-md bg-foreground px-5 py-2.5 text-sm font-medium text-background transition-opacity hover:opacity-90 disabled:opacity-50"
//       >
//         {completeIntegrationsMutation.isPending ? (
//           <>
//             <Loader2 className="h-4 w-4 animate-spin" />
//             Continuing...
//           </>
//         ) : (
//           <>
//             Continue
//             <ArrowRight className="h-4 w-4" />
//           </>
//         )}
//       </button>
//       <button
//         onClick={handleSkipScanning}
//         disabled={
//           skipScanningMutation.isPending ||
//           completeIntegrationsMutation.isPending ||
//           runCloudScanMutation.isPending ||
//           connectingProviderId !== null
//         }
//         className="text-sm text-muted-foreground underline-offset-2 hover:underline"
//       >
//         {skipScanningMutation.isPending ? 'Skipping...' : 'Skip'}
//       </button>
//     </>
//   )

//   return (
//     <ScreenataStepLayout
//       section="Infrastructure"
//       title="Infrastructure Integrations"
//       description="Connect your infrastructure to automatically collect compliance evidence."
//       footer={footer}
//       onBack={() =>
//         navigate({
//           to: '/workspaces/$workspaceId/connect-repo',
//           params: { workspaceId },
//         })
//       }
//       onNext={handleContinue}
//       disableNext={
//         skipScanningMutation.isPending ||
//         completeIntegrationsMutation.isPending ||
//         runCloudScanMutation.isPending ||
//         connectingProviderId !== null
//       }
//     >
//       {programQuery.isLoading ? (
//         <div className="flex items-center justify-center py-12">
//           <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
//         </div>
//       ) : (
//         <div className="space-y-3">
//           {PROVIDERS.map((provider) => {
//             const connection = connectionsByProvider.get(provider.id) ?? null
//             const connected = !!connection?.connected
//             const isActive = activeProvider.id === provider.id
//             const providerSummary = asSummary(connection?.lastScanSummary ?? null)
//             const isRunningThisProvider = runningProviderId === provider.id
//             const isOauthProvider = provider.id === 'gcp' || provider.id === 'azure'
//             const isConnectingThisProvider = connectingProviderId === provider.id

//             return (
//               <div
//                 key={provider.id}
//                 className={`w-full rounded-md border-2 px-5 py-4 text-left transition-all ${
//                   isActive
//                     ? 'border-primary bg-primary/5'
//                     : 'border-border hover:border-primary/50 hover:bg-muted/40'
//                 }`}
//                 onClick={() => setActiveProviderId(provider.id)}
//               >
//                 <div className="flex items-center gap-4">
//                   <provider.icon className="w-8 h-8 shrink-0" />
//                   <div className="flex-1 min-w-0">
//                     <div className="flex items-center gap-2">
//                       <span className="font-medium">{provider.name}</span>
//                       {connected ? (
//                         <span className="flex items-center gap-1 text-xs text-emerald-600">
//                           <CheckCircle2 className="w-3 h-3" />
//                           Connected
//                         </span>
//                       ) : (
//                         <span className="flex items-center gap-1 text-xs text-muted-foreground">
//                           <Circle className="w-3 h-3" />
//                           Not connected
//                         </span>
//                       )}
//                     </div>
//                     <p className="text-sm text-muted-foreground mt-0.5">
//                       {provider.description}
//                     </p>
//                     {connected && providerSummary && (
//                       <p className="mt-1 text-xs text-muted-foreground">
//                         Last scan: {providerSummary.pass} pass, {providerSummary.warn} warn, {providerSummary.fail} fail, {providerSummary.error} error
//                       </p>
//                     )}
//                     {connected && connection?.lastScanAt && (
//                       <p className="text-xs text-muted-foreground">
//                         Last scanned: {formatDate(connection.lastScanAt)}
//                       </p>
//                     )}
//                   </div>

//                   <div className="flex shrink-0 items-center gap-2">
//                     {connected ? (
//                       <>
//                         <button
//                           type="button"
//                           onClick={(event) => {
//                             event.stopPropagation()
//                             handleRunScan(provider.id)
//                           }}
//                           disabled={
//                             runCloudScanMutation.isPending ||
//                             disconnectCloudConnectionMutation.isPending ||
//                             connectingProviderId !== null
//                           }
//                           className="inline-flex items-center gap-1.5 rounded-md bg-foreground px-3 py-2 text-xs font-medium text-background transition-opacity hover:opacity-90 disabled:opacity-50"
//                         >
//                           {isRunningThisProvider ? (
//                             <Loader2 className="h-3.5 w-3.5 animate-spin" />
//                           ) : (
//                             <Play className="h-3.5 w-3.5" />
//                           )}
//                           {isRunningThisProvider ? 'Scanning...' : 'Run scan'}
//                         </button>
//                         <button
//                           type="button"
//                           onClick={(event) => {
//                             event.stopPropagation()
//                             if (provider.id === 'aws') {
//                               setSharedConfiguringProviderId(provider.id)
//                               return
//                             }
//                             connectProviderWithOAuth(provider.id)
//                           }}
//                           disabled={runCloudScanMutation.isPending || isConnectingThisProvider}
//                           className="inline-flex items-center gap-1.5 rounded-md border px-3 py-2 text-xs text-muted-foreground hover:text-foreground disabled:opacity-50"
//                         >
//                           {isConnectingThisProvider ? (
//                             <Loader2 className="h-3.5 w-3.5 animate-spin" />
//                           ) : (
//                             <RefreshCcw className="h-3.5 w-3.5" />
//                           )}
//                           {isConnectingThisProvider ? 'Connecting...' : (isOauthProvider ? 'Reconnect (OAuth)' : 'Reconnect')}
//                         </button>
//                         <button
//                           type="button"
//                           onClick={(event) => {
//                             event.stopPropagation()
//                             handleDisconnect(provider.id)
//                           }}
//                           disabled={
//                             disconnectCloudConnectionMutation.isPending ||
//                             runCloudScanMutation.isPending ||
//                             isConnectingThisProvider
//                           }
//                           className="inline-flex items-center gap-1.5 rounded-md border px-3 py-2 text-xs text-muted-foreground hover:text-destructive disabled:opacity-50"
//                         >
//                           <Trash2 className="h-3.5 w-3.5" />
//                           Disconnect
//                         </button>
//                       </>
//                     ) : (
//                       <button
//                         type="button"
//                         onClick={(event) => {
//                           event.stopPropagation()
//                           if (provider.id === 'aws') {
//                             setSharedConfiguringProviderId(provider.id)
//                             return
//                           }
//                           connectProviderWithOAuth(provider.id)
//                         }}
//                         disabled={isConnectingThisProvider}
//                         className="inline-flex items-center gap-1.5 rounded-md bg-foreground px-3 py-2 text-xs font-medium text-background transition-opacity hover:opacity-90"
//                       >
//                         {isConnectingThisProvider ? (
//                           <>
//                             <Loader2 className="h-3.5 w-3.5 animate-spin" />
//                             Connecting...
//                           </>
//                         ) : (
//                           'Connect'
//                         )}
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             )
//           })}

//           {activeConnection.connected && (
//             <div className="mt-4 space-y-3 rounded-md border bg-muted/10 p-3">
//               <p className="text-sm font-medium">
//                 {activeProvider.name} scan results
//               </p>
//               <ScanProgressBar
//                 percent={
//                   findingsQuery.data?.percent ??
//                   (runningProviderId === activeProvider.id ? 12 : 0)
//                 }
//               />
//               <div className="max-h-[260px] overflow-y-auto rounded-md border bg-background/70 p-2.5">
//                 <ScanFindingsFeed
//                   findings={findingsQuery.data?.findings ?? []}
//                   fallbackMessage={
//                     runningProviderId === activeProvider.id
//                       ? `Starting ${activeProvider.name} scan...`
//                       : `Run ${activeProvider.name} scan to collect infrastructure evidence.`
//                   }
//                 />
//               </div>
//               <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
//                 {activeConnection.lastTestStatus && (
//                   <span>
//                     Credential test: {activeConnection.lastTestStatus.toUpperCase()}
//                     {activeConnection.lastTestedAt ? ` at ${formatDate(activeConnection.lastTestedAt)}` : ''}
//                   </span>
//                 )}
//                 {activeConnection.lastScanSummary && asSummary(activeConnection.lastScanSummary) && (
//                   <span>
//                     Latest summary: {asSummary(activeConnection.lastScanSummary)?.pass} pass, {asSummary(activeConnection.lastScanSummary)?.warn} warn, {asSummary(activeConnection.lastScanSummary)?.fail} fail, {asSummary(activeConnection.lastScanSummary)?.error} error
//                   </span>
//                 )}
//               </div>
//             </div>
//           )}

//           <CloudConnectionDialog
//             provider={
//               configuringProviderId === 'aws'
//                 ? (PROVIDERS.find((provider) => provider.id === 'aws') ?? null)
//                 : null
//             }
//             open={configuringProviderId === 'aws'}
//             onOpenChange={(open) => {
//               if (!open) setSharedConfiguringProviderId(null)
//             }}
//             isSaving={upsertCloudConnectionMutation.isPending || testCloudConnectionMutation.isPending}
//             isOAuthConnecting={connectingProviderId !== null}
//             initialSummary={
//               configuringProviderId
//                 ? connectionsByProvider.get(configuringProviderId)?.configSummary ?? {}
//                 : {}
//             }
//             onSave={saveAndTestConnection}
//             onConnectOAuth={connectProviderWithOAuth}
//           />
//         </div>
//       )}
//     </ScreenataStepLayout>
//   )
// }
